import { SignInForm } from "../../Comp/auth/signIn/sign-in-form";

const SignIn = () => {
  return <SignInForm />;
};
export default SignIn;
